import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  getBackgroundLeft,
  getBackgroundRight,
  getBackgroundMobile,
} from 'client/site-modules/lease-deals/components/images/images';

import './lease-deals-gradient-container.scss';

export function LeaseDealsGradientContainer({ children, isMobile }) {
  return (
    <div
      className={classnames('lease-deals-gradient-container', {
        'is-mobile': isMobile,
      })}
    >
      <div aria-hidden className="background-gradient pos-a top-0 w-100" />
      <div className="background-mobile d-block d-md-none pos-a top-0 right-0">{getBackgroundMobile()}</div>
      <div className="background-left d-none d-md-block pos-a top-0">{getBackgroundLeft()}</div>
      <div className="background-right d-none d-md-block pos-a top-0 right-0">{getBackgroundRight()}</div>
      {children}
    </div>
  );
}

LeaseDealsGradientContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
